module.exports = __webpack_public_path__ + "img/40_fineStaff_zss.59a607d0.png";